import React, { useState, useEffect, useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useForgotPasswordMutation, useLoginMutation, useUpdatePasswordMutation } from "../../api/userSlice";
import { Button, Input, toastMessage } from "../utils";
import "./Login.css";
import LynkIdlogo from "../../Images/LynkID_Final.png";

import lynkidLoginCover from "../../Images/LoginPageCover.png";
import LynkitLogo from "../../Images/LynkitLogo.png";
import theme, { buttonClasses, textClasses } from "../utils/theme";
import { IconButton, Typography, Checkbox, FormControlLabel } from "@mui/material";
import { ArrowBack, MailOutline, PersonOutline, Person, PinOutlined, LockOutlined, VisibilityOff, Visibility } from "@mui/icons-material";
import { valid_email, valid_password } from "../../services/validation";
import { setFavicon, setTitle } from "../../services/functions";
import { themeMode } from "../../services/hooks";

/* =====LOCK STATES===== */
const LOCK_STATES = {
	IDLE: "idle",
	LOADING: "loading",
	SUCCESS: "success",
	FAIL: "fail",
};

/*======LOCK SHACKLE SVG===== */
function LockShackle({ borderColor, openPhase }) {
	return (
		<div
			className="lock-shackle"
			style={{
				transform:
					openPhase >= 2
						? "translateY(-30px) rotateY(180deg)"
						: openPhase >= 1
						? "translateY(-30px)"
						: "translateY(0)",
				transition:
					openPhase >= 2
						? "transform 0.8s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.6s ease 0.3s"
						: "transform 0.6s cubic-bezier(0.34, 1.56, 0.64, 1), opacity 0.4s ease",
				transformOrigin: "80% center",
			}}
		>
			<svg
				viewBox="0 0 281 211"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				style={{ display: "block", margin: "0 auto", width: "80%", height: "auto", maxHeight:"250px", overflow: "hidden" }}
				preserveAspectRatio="xMidYMid meet"
			>
				<defs>
					<clipPath id="clip0_221_9">
						<rect width="281" height="211" fill="white" />
					</clipPath>
					<mask id="mask0_221_9">
						<rect width="281" height="211" fill="white" />
					</mask>
				</defs>
				<g clipPath="url(#clip0_221_9)">
					<g mask="url(#mask0_221_9)">
						<path
							d="M279.645 210.066V140.072C279.645 62.9886 217.156 0.5 140.072 0.5C62.9887 0.5 0.5 62.9887 0.5 140.072V175.069"
							stroke={borderColor}
							style={{ transition: "stroke 0.5s ease" }}
						/>
						<path
							d="M255.309 210.066V143.51C255.309 79.8666 203.716 28.2734 140.072 28.2734C76.4284 28.2734 24.835 79.8666 24.835 143.51V175.069"
							stroke={borderColor}
							style={{ transition: "stroke 0.5s ease" }}
						/>
						<line y1="174.5" x2="25" y2="174.5" stroke={borderColor} style={{ transition: "stroke 0.5s ease" }} />
					</g>
				</g>
			</svg>
		</div>
	);
}

/* ======WHITE LABEL=====*/
const S3_WHITE_LABEL_URL = "https://whitelabling.s3.ap-south-1.amazonaws.com";
const logoPath = "logo.png";
const logoMiniPath = "miniLogo.png";
const logoBgPath = "loginBg.png";

function useWhiteLabelAssets() {
	const [assets, setAssets] = useState({
		logo: "",
		mini_logo: "",
		login_bg: "",
		favicon: "",
		title: "",
	});

	useLayoutEffect(() => {
		const hostPath = window.location.host.split(".").slice(-2).join(".");
		let title = window.location.host.split(".").slice(-2)[0];
		const s3Url = `${S3_WHITE_LABEL_URL}/${hostPath}`;

		const isWhiteLabeling = !(hostPath.includes("lynkid") || hostPath.includes("localhost"));
		// console.log({ isWhiteLabeling });
		if (isWhiteLabeling) {
			setAssets((o) => ({ ...o, logo: `${s3Url}/${logoPath}`, login_bg: `${s3Url}/${logoBgPath}`, mini_logo: `${s3Url}/${logoMiniPath}`, title }));
			setFavicon(`${s3Url}/${logoMiniPath}`);
			setTitle(title);

			if (hostPath.includes("tektronixit")) {
				themeMode("lightMode", "#008f79");
			}
		}
		
		// fetch(`https://whitelabling.s3.ap-south-1.amazonaws.com/tektronixit.com/logo.png`).then(res=>{
		// 	console.log(res)
		// })
		// setAssets((o) => ({
		// 	...o,
		// 	logo: `${S3_WHITE_LABEL_URL}/tektronixit.com/logo.png`,
		// 	mini_logo: `${S3_WHITE_LABEL_URL}/tektronixit.com/miniLogo.png`,
		// 	login_bg: `${S3_WHITE_LABEL_URL}/tektronixit.com/loginBg.png`,
		// 	title,
		// }));
		// themeMode("lightMode", "#008f79");

		// setTimeout(() => {
		// 	const logoImg = document.querySelector(".login_wrap section.bg img");
		// 	const logoCanvas = document.querySelector(".login_wrap section.bg canvas");

		// 	logoImg.crossOrigin = "Anonymous";
		// 	logoImg.onload = () => {
		// 		const canvas = logoCanvas;
		// 		const ctx = canvas.getContext("2d");

		// 		canvas.width = img.width;
		// 		canvas.height = img.height;
		// 		ctx.drawImage(img, 0, 0, img.width, img.height);

		// 		// Get pixel data
		// 		const imageData = ctx.getImageData(0, 0, img.width, img.height);
		// 		const data = imageData.data;

		// 		let r = 0,
		// 			g = 0,
		// 			b = 0,
		// 			count = 0;

		// 		// Loop through pixels (skip some to improve performance)
		// 		for (let i = 0; i < data.length; i += 4 * 50) {
		// 			r += data[i]; // Red
		// 			g += data[i + 1]; // Green
		// 			b += data[i + 2]; // Blue
		// 			count++;
		// 		}

		// 		// Calculate average color
		// 		r = Math.floor(r / count);
		// 		g = Math.floor(g / count);
		// 		b = Math.floor(b / count);

		// 		console.log(`rgb(${r}, ${g}, ${b})`)
		// 	};
		// }, 100);
	}, []);

	return assets;
}

/* ======LOGIN COMPONENT===== */
function Login() {
	useShowExpiredToast();
	const [isForgot, setIsForgot] = useState(false);
	const [lockState, setLockState] = useState(LOCK_STATES.IDLE);
	const [openPhase, setOpenPhase] = useState(0);
	const [shakeKey, setShakeKey] = useState(0);

	const handleReset = () => {
		setIsForgot(false);
		setLockState(LOCK_STATES.IDLE);
	};

	useEffect(() => {
		const url = localStorage.getItem("url");
		localStorage.clear();
		localStorage.setItem("url", url);
	}, []);

	const assets = useWhiteLabelAssets();

	const isSuccess = lockState === LOCK_STATES.SUCCESS;
	const isFail = lockState === LOCK_STATES.FAIL;

	const borderColor = isFail ? "#ff1744" : isSuccess ? "#00e676" : "#474747";
	const glow = isFail ? "rgba(255,23,68,0.45)" : isSuccess ? "rgba(0,230,118,0.45)" : "rgba(255,114,0,0.15)";

	// Two-phase shackle open
	useEffect(() => {
		if (isSuccess) {
			setOpenPhase(1);
			const t = setTimeout(() => setOpenPhase(2), 400);
			return () => clearTimeout(t);
		} else {
			setOpenPhase(0);
		}
	}, [isSuccess]);

	// Shake on fail
	useEffect(() => {
		if (isFail) setShakeKey((k) => k + 1);
	}, [isFail]);

	// Reset lock state when switching to forgot password
	useEffect(() => {
		if (isForgot) {
			setLockState(LOCK_STATES.IDLE);
		}
	}, [isForgot]);

	return (
		<div className="login_wrap">
			<section className="loginLeftPart">
				<div style={{ width: "inherit", height: "100%" }}>
					<div className="newLoginPageLogo">
						<img src={assets?.logo || LynkitLogo} alt="" />
					</div>
					<img src={lynkidLoginCover} alt="" className="newLoginInPageImg" />
				</div>
			</section>
			<section style={{ backgroundColor: "#000" }} className="rightPartLoginPage">
				{isForgot ? (
					/* ── Forgot password: no lock animation ── */
					<div className="forgot-password-container">
						<div className="form_wrap">
							<div>
								<div className="heading">
									<div style={{ display: "flex", alignItems: "center", color: "#CFCFCF" }}>
										<IconButton onClick={handleReset} >
											<ArrowBack style={{color:"#CFCFCF"}}/>
										</IconButton>
										<div style={{ flexBasis: "80%", display: "flex", alignItems: "center", justifyContent: "center", color: "#CFCFCF" }}>Reset Password</div>
										
									</div>
									<div>
										<img src={assets?.logo || LynkIdlogo} alt="" className="" />
									</div>
									<div style={{ color: "#CFCFCF", marginTop: "4px" }}>Yard & Asset Management System</div>
								</div>
								<ForgotPassword onClose={() => setIsForgot(false)} />
							</div>
						</div>
					</div>
				) : (
					/* ── Login: with lock animation ── */
					<div className="lock-assembly">
						<LockShackle borderColor={borderColor} openPhase={openPhase} />

						<div
							key={shakeKey}
							className={`form_wrap ${isFail ? "lock-shake" : ""}`}
							style={{
								borderColor: borderColor,
								boxShadow: `0 0 45px ${glow}, inset 0 1px 0 rgba(255,255,255,0.04)`,
								transition: "border-color 0.5s, box-shadow 0.5s",
							}}
						>
							<div>
								<div className="heading">
									<div>
										<img src={assets?.logo || LynkIdlogo} alt="" className="" />
									</div>
									<div style={{ color: "#CFCFCF", marginTop: "4px" }}>Yard & Asset Management System</div>
								</div>
								<LoginForm onForgot={() => setIsForgot(true)} setLockState={setLockState} />
							</div>
						</div>
					</div>
				)}
			</section>
		</div>
	);
}
export default Login;

/* ======LOGIN FORM===== */
function LoginForm({ onForgot, setLockState }) {
	const [formData, setFormData] = useState({
		email: "",
		password: "",
	});
	const [error, setError] = useState({});
	const handleInput = (e) => {
		const { name, value } = e.target;
		setFormData((old) => ({ ...old, [name]: value }));
	};
	const navigate = useNavigate();
	const [passwordType, setPasswordType] = useState("password");
	const [handleLogin, { isLoading }] = useLoginMutation();
	const togglePassType = () => {
		if (passwordType == "password") {
			setPasswordType("text");
		} else {
			setPasswordType("password");
		}
	};
	const handleShowPasswordKeyDown = (e) => {
		if (e.key === "Enter") {
			e.preventDefault();
			togglePassType();
		}
	};

	const handleFormValidation = () => {
		// console.log("validating");
		let error = {};

		if (!formData.email) return toastMessage(false, "Email is required");
		if (!valid_email(formData.email)) return toastMessage(false, "Please enter a valid email");

		if (!formData.password) return toastMessage(false, "Password is required");
			// else if (!valid_password(formData.password))
			// 	error.password = "Password should contain minimum 8 characters, including at least 1 uppercase letter, 1 lowercase letter, 1 special character, and 1 number.";

		if (Object.keys(error).length) {
			setError(error);
		} else {
			setError({});
			handleFormSubmit();
		}
	};

	const handleFormSubmitEvent = (e) => {
		e.preventDefault();
		handleFormValidation();
	};

	const handleFormSubmit = async () => {
		const trimmedData = {
			email: formData.email.trim(),
			password: formData.password.trim(),
		};
		setLockState(LOCK_STATES.LOADING);
		const {
			data: { error, message, token, permissions, email },
		} = await handleLogin(trimmedData);

		if (error) {
			setLockState(LOCK_STATES.FAIL);
			setTimeout(() => setLockState(LOCK_STATES.IDLE), 2200);
			toastMessage(false, message);
		} else {
			setLockState(LOCK_STATES.SUCCESS);
			localStorage.setItem("secretkey", token);
			localStorage.setItem("userDetail", email);
			setTimeout(() => navigate("/loading"), 1500);
		}
	};

	return (
		<form onSubmit={handleFormSubmitEvent}>
			<div className="login-field">
				<MailOutline className="login-field-icon" />
				<input
					type="email"
					name="email"
					placeholder="Email / Mobile Number"
					value={formData.email}
					onChange={handleInput}
					className="login-field-input"
				/>
			</div>
			<div className="login-field">
				<PersonOutline className="login-field-icon" />
				<input
					type={passwordType}
					name="password"
					placeholder="Password"
					value={formData.password}
					onChange={handleInput}
					className="login-field-input"
				/>
			</div>

			<div className="login-options-row">
				<FormControlLabel
					control={
						<Checkbox
							checked={passwordType === "text"}
							onChange={togglePassType}
							size="small"
							sx={{
								color: "#555",
								padding: "2px",
								"&.Mui-checked": { color: theme.themeOrange },
							}}
							inputProps={{
								onKeyDown: handleShowPasswordKeyDown,
								"aria-label": "Show password",
							}}
						/>
					}
					label="Show password"
					sx={{
						margin: 0,
						"& .MuiFormControlLabel-label": {
							fontSize: "12px",
							color: "#999",
						},
					}}
				/>
				<button type="button" className="login-forgot-link" onClick={onForgot}>
					Forgot Password?
				</button>
			</div>
			{/* <Button
				text="Sign In"
				onClick={handleFormSubmit}
				style={{
					...buttonClasses.lynkitOrangeFill,
					borderRadius: "12px",
					boxShadow: "rgba(0, 0, 0, 0.25) 0px 4px 4px",
					height: "48px",
					fontWeight: "600",
					fontSize: "1rem",
					lineHeight: "22px",
					textTransform: "none",
				}}
				disabled={isLoading}
			/>  */}
			<button
				type="submit"
				className="login-submit-btn"
				disabled={isLoading}
			>
				<Person style={{ fontSize: 20 }} />
				<span>Sign In</span>
			</button>

			<div className="login-contact-row">
				<span>Don't have an account ?</span>{" "}
				<a href="https://support.lynkit.in/portal/en/newticket?departmentId=43764000213501179&layoutId=43764000213692612" target="_blank" className="login-contact-link">Contact Us</a>
			</div>
		</form>
	);
}

/* ======useShowExpiredToast=======*/
function useShowExpiredToast() {
	useEffect(() => {
		if (window.localStorage.getItem("isExpired")) {
			toastMessage(false, "Session Expired! Please login again...");
			window.localStorage.removeItem("isExpired");
		}
	}, []);
}
function ForgotPassword({ open, onClose }) {
	const [formData, setFormData] = useState({
		email: "",
		projectId: "LYNKID",
	});
	const [error, setError] = useState({});
	const [isOtpSent, setIsOtpSent] = useState(false);
	const [seconds, setSeconds] = useState(0);

	const handleInput = (e) => {
		const { name, value } = e.target;
		setFormData((old) => ({ ...old, [name]: value }));
	};
	const [handleForgotPass, { isLoading: isHandlingForgot }] = useForgotPasswordMutation();
	const [handleChangePass, { isLoading: isHandlingUpdate }] = useUpdatePasswordMutation();

	const handleFormSubmit = async (resend = false) => {
		let payload = {
			email: formData.email.trim(),
			projectId: "LYNKID",
		};

		if (isOtpSent && !resend) {
			payload = {
				...payload,
				email: formData?.email?.trim()?.toLowerCase(),
				otp: formData.otp,
				newPassword: formData.newPassword.trim(),
			};
		}

		const {
			data: { success, message },
		} = isOtpSent && !resend ? await handleChangePass(payload) : await handleForgotPass(payload);
		if (!success) {
			toastMessage(false, message);
		} else {
			toastMessage(true, message);
			if (!isOtpSent || resend) {
				setIsOtpSent(true);
				setSeconds(60);
			} else {
				handleClose();
			}
		}
	};
	const handleClose = () => {
		setFormData({});
		onClose();
	};

	const handleFormValidation = () => {
		let error = {};

		if (!isOtpSent) {
			if (!formData.email) error.email = "Email is required";
			else if (!valid_email(formData.email)) error.email = "Please enter a valid email";
		} else {
			if (!formData.otp) error.otp = "Please enter the OTP";
			if (!formData.newPassword) error.newPassword = "Password is required";
			else if (!valid_password(formData.newPassword))
				error.newPassword = "Password should contain minimum 8 characters, including at least 1 uppercase letter, 1 lowercase letter, 1 special character, and 1 number.";

			if (!formData.confirmPassword) error.confirmPassword = "Confirm new password";
			else if (formData.confirmPassword !== formData.newPassword) error.confirmPassword = "Passwords do not match";
		}

		if (Object.keys(error).length) {
			setError(error);
		} else {
			setError({});
			handleFormSubmit();
		}
	};

	const [passType, setPassType] = useState("password");
	const togglePassType = () => setPassType(passType == "password" ? "text" : "password");
	const [confPassType, setConfPassType] = useState("password");
	const toggleConfPassType = () => setConfPassType(confPassType == "password" ? "text" : "password");

	useEffect(() => {
		if (!isOtpSent) return;

		// console.log("interval usereffect");

		let interval = setInterval(() => {
			setSeconds((s) => {
				if (s == 0) {
					// console.log("reset to 0");
					clearInterval(interval);
					return 0;
				}
				return s - 1;
			});
		}, 1000);

		return () => clearInterval(interval);
	}, [isOtpSent]);

	return (
		<form className="form-inputs-login">
			{/* ── Email (before OTP) ── */}
			{!isOtpSent ? (
				<div className="login-field-wrapper">
					<div className={`login-field ${error.email ? "login-field-error" : ""}`}>
						<MailOutline className="login-field-icon" />
						<input
							type="email"
							name="email"
							placeholder="Enter your email"
							value={formData.email}
							onChange={handleInput}
							className="login-field-input"
						/>
					</div>
					{error.email && <span className="login-field-error-text">{error.email}</span>}
				</div>
			) : null}

			{/* ── OTP + Passwords (after OTP sent) ── */}
			{isOtpSent ? (
				<>
					<div className="login-field-wrapper">
						<div className={`login-field ${error.otp ? "login-field-error" : ""}`}>
							<PinOutlined className="login-field-icon" />
							<input
								type="text"
								name="otp"
								placeholder="Enter OTP"
								value={formData.otp || ""}
								onChange={handleInput}
								className="login-field-input"
							/>
						</div>
						{error.otp && <span className="login-field-error-text">{error.otp}</span>}
					</div>

					<div className="login-field-wrapper">
						<div className={`login-field ${error.newPassword ? "login-field-error" : ""}`}>
							<LockOutlined className="login-field-icon" />
							<input
								type={passType}
								name="newPassword"
								placeholder="Enter new password"
								value={formData.newPassword || ""}
								onChange={handleInput}
								className="login-field-input"
							/>
							<IconButton onClick={togglePassType} size="small" sx={{ color: "#666", padding: "4px" }}>
								{passType === "password" ? <VisibilityOff sx={{ fontSize: 18 }} /> : <Visibility sx={{ fontSize: 18 }} />}
							</IconButton>
						</div>
						{error.newPassword && <span className="login-field-error-text">{error.newPassword}</span>}
					</div>

					<div className="login-field-wrapper">
						<div className={`login-field ${error.confirmPassword ? "login-field-error" : ""}`}>
							<LockOutlined className="login-field-icon" />
							<input
								type={confPassType}
								name="confirmPassword"
								placeholder="Confirm new password"
								value={formData.confirmPassword || ""}
								onChange={handleInput}
								className="login-field-input"
							/>
							<IconButton onClick={toggleConfPassType} size="small" sx={{ color: "#666", padding: "4px" }}>
								{confPassType === "password" ? <VisibilityOff sx={{ fontSize: 18 }} /> : <Visibility sx={{ fontSize: 18 }} />}
							</IconButton>
						</div>
						{error.confirmPassword && <span className="login-field-error-text">{error.confirmPassword}</span>}
					</div>

					{seconds == 0 ? (
						<Button
							variant="text"
							style={{
								...textClasses.boldText,
								color: theme.themeOrange,
								textDecoration: "underline",
								cursor: "pointer",
								textTransform: "none",
							}}
							text="Resend OTP"
							onClick={() => handleFormSubmit(true)}
							disabled={isHandlingForgot}
						/>
					) : (
						<Typography
							sx={{
								...textClasses.boldText,
								textTransform: "none",
							}}
						>
							Resend OTP in {seconds} seconds
						</Typography>
					)}{" "}
				</>
			) : null}

			<button
				type="button"
				className="login-submit-btn"
				onClick={handleFormValidation}
				disabled={isHandlingForgot || isHandlingUpdate}
			>
				<span>{isOtpSent ? "Submit" : "Get OTP"}</span>
			</button>
			<div className="login-contact-row">
				<span>Don't have an account ?</span>{" "}
				<a href="https://support.lynkit.in/portal/en/newticket?departmentId=43764000213501179&layoutId=43764000213692612" target="_blank" className="login-contact-link">Contact Us</a>
			</div>
		</form>
	);
}
